import { FC } from 'react';

import { ICommonResponse } from 'api/types';
import { AcademicYearTitle } from 'components/pdfStudent';
import { splittedDataToSortedArray } from 'containers/pdfStudent/utils';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetProfessionGia } from 'icons/widgets';
import { GiaWorldskillsCard } from 'portfolio3/features/pdf/components/cards';
import GridLayout from 'portfolio3/features/pdf/components/GridLayout';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { IGiaWorldSkillsEntity } from 'types';
import { getAcademicYearByDate, getDataLoadRequests, isDateValid } from 'utils';

import { professionGiaWorldSkillsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const splitGiaWorldskillsByAcademicData = (data: ICommonResponse<IGiaWorldSkillsEntity>, academicYears: string[]) => {
  const learningYearData: Record<string, IGiaWorldSkillsEntity[]> = {};

  data.content.forEach((item) => {
    // Если не задана дата результата, то для опрделения периода используем дату создания
    const date = new Date(item.resultDate ?? item.creationDate);

    if (isDateValid(date)) {
      const period = getAcademicYearByDate(date);
      if (academicYears.includes(period)) {
        if (learningYearData[period]) {
          learningYearData[period].push(item);
        } else {
          learningYearData[period] = [item];
        }
      }
    }
  });

  return splittedDataToSortedArray(learningYearData);
};

const PdfGiaWorldskillsContainer: FC = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const giaWorldskills = useAppSelector(professionGiaWorldSkillsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().professionGiaWorldSkills });

  const hasData = giaWorldskills.content.length > 0;
  const academicYearData = splitGiaWorldskillsByAcademicData(giaWorldskills, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Демонстрационные экзамены" Icon={IconWidgetProfessionGia}>
      {hasData &&
        academicYearData.map(([academicYear, data]) => (
          <div key={academicYear}>
            <AcademicYearTitle academicYear={academicYear} />
            <GridLayout gap="16px">
              {data.map((entity) => {
                return <GiaWorldskillsCard key={entity.id} entity={entity} />;
              })}
            </GridLayout>
          </div>
        ))}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfGiaWorldskillsContainer;
